var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { withAppName } from './api-service';
// Short TTL: the two join-flow callers run within a couple of seconds of each
// other, but validity can change over a long-lived tab, so entries expire.
const TTL_MS = 30000;
const cache = new Map();
/** Drop cached validations (all, or one token). Call on an explicit Retry. */
export function clearInterviewTokenCache(token) {
    if (token)
        cache.delete(token);
    else
        cache.clear();
}
/**
 * Fetch — and de-duplicate — `GET /api/get-interview-from-token/`.
 *
 * The interview-join flow validates the same token twice: once in the meeting
 * widget (to pick the cost-optimized vs realtime engine) and again in the setup
 * bootstrap (for candidate + JD metadata). Both now go through this helper, so
 * the second caller reuses the first in-flight/completed result instead of
 * hitting the backend again — one fewer round-trip on every join.
 *
 * Only SUCCESSFUL (ok) results are cached. A rejection (network) or a non-ok
 * verdict (expired/cancelled/…/5xx) is never cached, so a Retry — or a
 * rescheduled interview that is now valid — always re-validates.
 */
export function fetchInterviewFromToken(apiBaseUrl, token) {
    const existing = cache.get(token);
    if (existing && Date.now() - existing.ts < TTL_MS)
        return existing.promise;
    const promise = (() => __awaiter(this, void 0, void 0, function* () {
        const res = yield fetch(withAppName(`${apiBaseUrl}/api/get-interview-from-token/?token=${encodeURIComponent(token)}`), 
        // no-store: never replay a cached 403/409/410 from the browser disk cache.
        { cache: 'no-store' });
        let data = null;
        let errorText;
        try {
            const body = yield res.json();
            if (res.ok)
                data = body;
            else if (body && typeof body.error === 'string')
                errorText = body.error;
        }
        catch (_a) {
            /* non-JSON body — fall back to status-only messaging */
        }
        // Don't keep a rejection cached — Retry must re-hit the backend.
        if (!res.ok)
            cache.delete(token);
        return { ok: res.ok, status: res.status, data, errorText };
    }))();
    cache.set(token, { ts: Date.now(), promise });
    // A thrown fetch (network/CORS) must also evict, so a retry re-fetches.
    promise.catch(() => cache.delete(token));
    return promise;
}
